import { defineMessages } from "react-intl";

export const CurrencyManageMessages = defineMessages({
  entityName: {
    id: "CurrencyManager.title",
    defaultMessage: "Currencies",
  },
  defaultCurrency: {
    id: "CurrencyManager.defaultCurrency",
    defaultMessage: "Default currency",
  },
  name: {
    id: "app.name",
    defaultMessage: "name",
  },
  code: {
    id: "app.code",
    defaultMessage: "code",
  },
  default: {
    id: "app.default",
    defaultMessage: "default",
  },
  visible: {
    id: "app.visible",
    defaultMessage: "visible",
  },
  save: {
    id: "default.save",
    defaultMessage: "Save",
  },
  saveSuccess: {
    id: "default.saveSuccess",
    defaultMessage: "Saved successfully",
  },
});

export const tableHeaderMessages = defineMessages({
  primary: {
    id: "app.default",
    defaultMessage: "default",
  },
  name: {
    id: "app.name",
    defaultMessage: "name",
  },
  code: {
    id: "app.code",
    defaultMessage: "code",
  },
  default: {
    id: "app.default",
    defaultMessage: "default",
  },
  visible: {
    id: "app.visible",
    defaultMessage: "visible",
  },
});
